module.exports = __webpack_public_path__ + "static/media/docx.62179ba8.svg";